import { render, staticRenderFns } from "./ImgTabs.vue?vue&type=template&id=8c72110a&scoped=true&"
import script from "./ImgTabs.vue?vue&type=script&lang=js&"
export * from "./ImgTabs.vue?vue&type=script&lang=js&"
import style0 from "./ImgTabs.vue?vue&type=style&index=0&id=8c72110a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c72110a",
  null
  
)

export default component.exports